import TaskModel from 'core/gd-model/task/gd-task';

export default class GDSharedTaskView {

    init() {

    }

    getOptions() {
        return this.options ? this.options : {};
    }

    open(taskId, getTasksListFunc, options) {
        this.taskId = taskId;
        this.options = options;

        const path = window.location.pathname.split('/');
        const task = new TaskModel({ id:this.taskId, urlPrefix: [path[1],'t'].join('/')});

        if (task.url.indexOf("TEMP_ID") === -1) gd.goTo(task.url, this.options);
        else console.log("GDSharedTaskView: task is not yet fully added", task.url, this.options);

        gd.bus.triggerEvent(gd.const.busEvents.taskViewOpen, task);
    }
}